import { GetterTree } from 'vuex'
import { ModuleState } from './types'
import { RootState } from '@/types'

export const getters: GetterTree<ModuleState, RootState> = {
  items(state) { return state.items }
}
